import { generateTypes } from '../../utils/HttpReducerHelper';

export const actions = generateTypes('DASHBOARD', 'ACTIONS');
